/* OVO product pages - shared behaviour (AIOS 2026-08-25). Safe to include many times. */
(function () {
  if (window.__ovopJs) return;
  window.__ovopJs = true;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.ovop-reveal:not(.is-in)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  function initVideos() {
    document.querySelectorAll('[data-ovop-video]:not([data-ovop-ready])').forEach(function (btn) {
      btn.setAttribute('data-ovop-ready', '1');
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-ovop-video');
        var f = document.createElement('iframe');
        f.className = btn.className;          // bez tego iframe traci wymiary (304x154)
        f.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0');
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', btn.getAttribute('data-ovop-title') || 'Video');
        btn.replaceWith(f);
      });
    });
  }

  function initAr() {
    document.querySelectorAll('[data-ovop-ar]:not([data-ovop-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ovop-ready', '1');
      var btn = wrap.querySelector('.ovop-ar__btn');
      var modal = wrap.querySelector('.ovop-ar__modal');
      var close = wrap.querySelector('.ovop-ar__close');
      var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (!btn || !modal) return;
      if (!isMobile) {
        btn.addEventListener('click', function (e) { e.preventDefault(); modal.classList.add('is-open'); });
        if (close) close.addEventListener('click', function () { modal.classList.remove('is-open'); });
        modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('is-open'); });
      }
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-ovop-car]:not([data-ovop-ready])').forEach(function (car) {
      car.setAttribute('data-ovop-ready', '1');
      var track = car.querySelector('.ovop-cl__car-track');
      var prev = car.querySelector('[data-ovop-car-prev]');
      var next = car.querySelector('[data-ovop-car-next]');
      if (!track) return;
      function step() {
        var first = track.querySelector('figure');
        return first ? first.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      }
      var eagerDone = false;
      function loadAll() {
        if (eagerDone) return;
        eagerDone = true;
        track.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
        if (track.scrollLeft > 2) loadAll();
      }
      if (prev) prev.addEventListener('click', function () { loadAll(); track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { loadAll(); track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
      // panel moze byc zwiniety przy starcie - przelicz po otwarciu
      var panel = car.closest('details');
      if (panel) panel.addEventListener('toggle', function () { setTimeout(sync, 60); });
    });
  }

  function initTabs() {
    var panes = document.querySelectorAll('.ovop-tabpane:not([data-ovop-ready])');
    if (!panes.length) return;
    var groups = [];
    panes.forEach(function (pane) {
      pane.setAttribute('data-ovop-ready', '1');
      var host = pane.closest('.shopify-section') || pane.parentElement;
      var last = groups[groups.length - 1];
      if (last && last[last.length - 1].host.nextElementSibling === host) last.push({ pane: pane, host: host });
      else groups.push([{ pane: pane, host: host }]);
    });
    groups.forEach(function (group) {
      if (group.length < 2) return;                 // pojedyncza zakladka = zwykla sekcja
      var bar = document.createElement('div');
      bar.className = 'ovop-tabbar';
      var wrap = document.createElement('div');
      wrap.className = 'ovop ovop-tabbar__wrap';
      var inner = document.createElement('div');
      inner.className = 'ovop-wrap';
      inner.appendChild(bar);
      wrap.appendChild(inner);
      group[0].host.parentNode.insertBefore(wrap, group[0].host);
      group.forEach(function (item, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ovop-tabbar__btn' + (i === 0 ? ' is-active' : '');
        btn.textContent = item.pane.getAttribute('data-tab-title') || ('Tab ' + (i + 1));
        btn.addEventListener('click', function () {
          group.forEach(function (other, j) {
            other.host.hidden = j !== i;
            bar.children[j].classList.toggle('is-active', j === i);
          });
          window.dispatchEvent(new Event('resize'));
        });
        bar.appendChild(btn);
        item.pane.classList.add('ovop-tabs-on');
        item.host.hidden = i !== 0;
      });
    });
  }

  function boot() { initReveal(); initVideos(); initAr(); initCarousels(); initTabs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
